import { RouteObject } from 'react-router-dom';
import { routes } from '../../routes';
import ProductCategoryPage from './products/category/ProductCategoryPage';
import ProductDetailPage from './products/detail/ProductDetailPage';
import StoreDepartmentsPage from './departments/StoreDepartmentsPage';

export const storeRoutes: RouteObject[] = [
  {
    path: `${routes.STORE_PRODUCTS}/:category/:name`,
    element: <ProductDetailPage />,
  },
  {
    path: `${routes.STORE_PRODUCTS}/:category`,
    element: <ProductCategoryPage />,
  },
  {
    path: `${routes.STORE_DEPARTMENTS}`,
    element: <StoreDepartmentsPage />,
  },
  {
    path: `${routes.STORE_DEPARTMENTS}/:department`,
    element: <StoreDepartmentsPage />,
  },
];
